// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".agents-invitation{text-align:center;font-size:34px;color:#00b400;margin:0 auto;padding:134px}", "",{"version":3,"sources":["/app/src/views/agencyInvitation/agencyInvitation.scss"],"names":[],"mappings":"AAAA,mBACI,iBAAkB,CAClB,cAAe,CACf,aAAc,CACd,aAAc,CACd,aAAc","file":"AgencyInvitation.vue?vue&type=style&index=0&lang=scss&","sourcesContent":[".agents-invitation{\n    text-align: center;\n    font-size: 34px;\n    color: #00b400;\n    margin: 0 auto;\n    padding: 134px;\n}"]}]);
// Exports
module.exports = exports;
